import { useLocation } from "react-router-dom";

export const useIsCaLiveRoute = (): boolean => {
    const location = useLocation();
    const pathname = location?.pathname ?? "";
    return pathname === "/ca-live";
};

export const useIsDashboardRoute = (): boolean => {
    const location = useLocation();
    const pathname = location?.pathname ?? "";
    return pathname === "/dashboard";
};

